import React, { useState, useEffect } from 'react';
import api from '../../api/axios';
import WebsiteDetail from '../Website/WebsiteDetail';
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Box,
  CircularProgress,
} from '@mui/material';

function Search() {
  const [query, setQuery] = useState('');
  const [searchData, setSearchData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [selectedWebsite, setSelectedWebsite] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (query) {
          const response = await api.get('websites/', {
            params: {
              search: query,
              page: page
            },
          });
          setSearchData(response.data);
        } else {
          setSearchData(null);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    // Add debounce to prevent too many API calls while typing
    const timeoutId = setTimeout(fetchData, 300);
    return () => clearTimeout(timeoutId);
  }, [query, page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleWebsiteClick = (website) => {
    setSelectedWebsite(website);
  };
  if (selectedWebsite) {
    return (
      <WebsiteDetail 
        website={selectedWebsite} 
        onBack={() => setSelectedWebsite(null)} 
      />
    );
  }

  return (
    <div className="container mt-4">
      <TextField
        label="Search Websites"
        variant="outlined"
        fullWidth
        margin="normal"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      
      {loading && (
        <Box display="flex" justifyContent="center" m={3}>
          <CircularProgress />
        </Box>
      )}

      {searchData?.results && searchData.results.length > 0 && (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Domain</TableCell>
                  <TableCell>Rank</TableCell>
                  <TableCell>Is WordPress</TableCell>
                  <TableCell>Is WooCommerce</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchData.results.map((website) => (
                  <TableRow 
                    key={website.id}
                    onClick={() => handleWebsiteClick(website)}
                    style={{ cursor: 'pointer' }}
                    hover
                  >
                    <TableCell>{website.domain}</TableCell>
                    <TableCell>{website.rank}</TableCell>
                    <TableCell>{website.is_wordpress ? 'Yes' : 'No'}</TableCell>
                    <TableCell>{website.is_woocommerce ? 'Yes' : 'No'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={Math.ceil(searchData.count / 10)}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        </>
      )}

      {query && searchData?.results?.length === 0 && (
        <Box textAlign="center" mt={3}>
          No results found
        </Box>
      )}
    </div>
  );
}

export default Search;